import { render } from "./whr-carousel.vue?vue&type=template&id=a4efa9cc&scoped=true&ts=true"
import script from "./whr-carousel.vue?vue&type=script&lang=ts"
export * from "./whr-carousel.vue?vue&type=script&lang=ts"

import "./whr-carousel.vue?vue&type=style&index=0&id=a4efa9cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4efa9cc"]])

export default __exports__